/* src/app/weighbridge/pages/weighbridge-yard-trade/weighbridge-yard-trade.component.scss */
/*# sourceMappingURL=weighbridge-yard-trade.component.css.map */
